import React from 'react';

type AppErrorBoundaryProps = React.PropsWithChildren;

interface AppErrorBoundaryState {
  hasError: boolean;
  errorMessage: string | null;
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  declare props: AppErrorBoundaryProps;

  state: AppErrorBoundaryState = {
    hasError: false,
    errorMessage: null,
  };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return {
      hasError: true,
      errorMessage: error?.message || '未知异常',
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('AppErrorBoundary caught an error:', error, errorInfo);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="min-h-screen bg-slate-50 text-slate-900 flex items-center justify-center p-6">
        <section className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white shadow-xl p-6">
          <h1 className="text-xl font-semibold tracking-tight">页面加载失败</h1>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            应用在渲染时遇到了异常。请点击下方按钮刷新页面，如果仍然失败，请把报错信息发给我继续排查。
          </p>
          <div className="mt-4 rounded-lg bg-slate-100 p-3 text-xs text-slate-600 break-all">
            {this.state.errorMessage || '未获取到错误详情'}
          </div>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-5 inline-flex items-center justify-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            刷新重试
          </button>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;
